import {BaseRua} from "./rua.model";

export class AccountRua extends BaseRua {
  // UI working fields
  ruaUserFileName = ''; // user submitted filename for UI display
  ruaUserFileSize = 0;
  ruaUserFileType = '';
  ruaParcelFileName = ''; // filename for REST call, e.g., 'midwest_RUA', or <region>_RUA
  attachmemtContent = '';  // rua PDF content in byte array
  now: Date = null;

  private _isValidContractNumber = false;
  private _isValidExpirationDate = false;
  private _isValidFileSize = false;
  private _isValidFileType = false;

  constructor(region: string) {
    super();
    this.now = new Date();
    this.region = region;
    this.ruaParcelFileName = this.region + '_RUA';
  }

  get isValidContractNumber(): boolean {
    return this._isValidContractNumber;
  }

  set isValidContractNumber(isValidContractNumber: boolean) {
    this._isValidContractNumber = isValidContractNumber;
  }

  get isValidExpirationDate(): boolean {
    return this._isValidExpirationDate;
  }

  set isValidExpirationDate(isValidExpirationDate: boolean) {

    this._isValidExpirationDate = isValidExpirationDate;
  }

  get isValidFileSize(): boolean {
    return this._isValidFileSize;
  }

  set isValidFileSize(isValidFileSize: boolean) {
    this._isValidFileSize = isValidFileSize;
  }

  get isValidFileType(): boolean {
    return this._isValidFileType;
  }

  set isValidFileType(isValidFileType: boolean) {
    this._isValidFileType = isValidFileType;
  }

  get isValidAccountRua(): boolean {
    return this._isValidContractNumber
      && this._isValidExpirationDate
      && this._isValidFileSize
      && this._isValidFileType;
  }
}
